import type { School } from 'types';
import { getCatalogKind } from 'constants/platformCatalogRegistry';

export function isSchoolActive(school: School): boolean {
  return school.status === 'active';
}

/** Active learner schools only - excludes platform features and knowledge topics. */
export function getLearnerVisibleSchools(schools: School[]): School[] {
  return schools.filter(
    (school) => isSchoolActive(school) && getCatalogKind(school.slug) === 'school',
  );
}
